import LoginError from './LoginError';
class InvalidCode extends LoginError {
    constructor(options) {
        super('Code provided by user is not valid', options);
    }
}
export default InvalidCode;
